import { DirectUploadUrl } from '@shared/interfaces/FileStorage';

export class FileStorageApi {
  static async uploadFile (upload: DirectUploadUrl, file: File): Promise<void> {
    let response: Response;
    if (upload.method === 'PUT') {
      response = await fetch(upload.url, { body: file, method: 'PUT' });
    } else {
      const data = new FormData();
      data.append('file', file);
      data.append('storageKey', upload.storageKey);
      response = await fetch(upload.url, {
        body: data,
        credentials: 'include',
        method: 'POST',
      });
    }
    if (!response.ok) {
      throw new Error('Failed to upload file');
    }
  }
}
